import { IDocumentPackage } from "@rentiohq/shared-frontend/dist/types/documentPackage.types";
import { Lozenge } from "@rentiohq/web-shared/dist/components";
import { getUniqueSigners } from "scenes/FollowUp/DocumentPackages/DocumentPackages.utils";
import { getSignerInfo } from "utils/documentPackage.utils";
import { ts } from "../../../../services";
import * as documentPackageUtils from "../../../../utils/documentPackage.utils";

export const getDocumentPackageStatusLozenge = (params: {
  documentPackage: IDocumentPackage;
}) => {
  const { documentPackage } = params;

  const simpleStage =
    documentPackage.status &&
    documentPackageUtils.getSimpleStages(documentPackage.status);
  const { signedCount } = getSignerInfo(documentPackage);

  const uniqueSigners = getUniqueSigners(documentPackage);

  const stageReadable = ts.followUpDocumentPackagesFilterStageLabel({
    extra: { key: simpleStage },
  });
  const signerCountReadable = `${signedCount}/${uniqueSigners.length}`;

  return (
    <Lozenge
      isBold
      key={`${documentPackage.id}-document_package-status`}
      appearance={documentPackageUtils.getStatusStageVariation(
        documentPackage.status,
      )}
    >
      {`${stageReadable}: ${signerCountReadable}`}
    </Lozenge>
  );
};
